// extracted by mini-css-extract-plugin
export default {"renderItemDetail":"orders__renderItemDetail__uQI2Q5","buy":"orders__buy__mQrr0x","sell":"orders__sell__Ppr2JZ","orderRow":"orders__orderRow__pVWMhT"};